"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var slider_1 = require("@material/slider");
//@ts-ignore
require("../theme.ts");
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slider.prototype.installed = function () {
        var _this = this;
        var slider = new slider_1.MDCSlider(this.shadowRoot.querySelector('.mdc-slider'));
        slider.listen('MDCSlider:change', function () {
            _this.fire('change', { value: slider.value });
        });
    };
    Slider.prototype.render = function (props) {
        var count = (props.max - props.min) / props.step;
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-slider', {
            'mdc-slider--discrete': props.discrete,
            'mdc-slider--display-markers': props.displayMarkers
        }), { tabIndex: 0, role: "slider", "aria-valuemin": props.min, "data-step": props.step, "aria-valuemax": props.max, "aria-valuenow": props.value, "aria-label": "Select Value", "aria-disabled": props.disabled }),
            omi_1.h("div", { class: "mdc-slider__track-container" },
                omi_1.h("div", { class: "mdc-slider__track" }),
                props.displayMarkers && omi_1.h("div", { class: "mdc-slider__track-marker-container" }, new Array(count).map(function (_) { return omi_1.h("div", { class: "mdc-slider__track-marker" }); }))),
            omi_1.h("div", { class: "mdc-slider__thumb-container" },
                props.discrete && omi_1.h("div", { class: "mdc-slider__pin" },
                    omi_1.h("span", { class: "mdc-slider__pin-value-marker" })),
                omi_1.h("svg", { class: "mdc-slider__thumb", width: "21", height: "21" },
                    omi_1.h("circle", { cx: "10.5", cy: "10.5", r: "7.875" })),
                omi_1.h("div", { class: "mdc-slider__focus-ring" }))));
    };
    Slider.css = css;
    Slider.defaultProps = {
        value: 0,
        step: 1,
        min: 0,
        max: 100
    };
    Slider.propTypes = {
        discrete: Boolean,
        value: Number,
        disabled: Boolean,
        min: Number,
        max: Number,
        step: Number,
        displayMarkers: Boolean
    };
    Slider = __decorate([
        omi_1.tag('m-slider')
    ], Slider);
    return Slider;
}(omi_1.WeElement));
exports.default = Slider;
